import { QueryProps } from "@/types/Api";
import { UserPreferences } from "@/types/ApiResponses/UserPreferences";
import { api } from "..";

export const getPreferences = async (
  props: QueryProps
): Promise<UserPreferences> => {
  const res = await api.client.get("/user-preferences", {
    signal: props.signal,
  });
  return res.data;
};
